module.exports = __webpack_public_path__ + "static/img/9.ddbce6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/video-group/9.jpg
// module id = 429p
// module chunks = 1